import * as React from 'react'
import { adminService } from '../../../../../services'
import { toast } from 'react-toastify'
import { Button, Form, Label, Segment, TextArea } from 'semantic-ui-react'
import { TextAreaProps } from 'semantic-ui-react/dist/commonjs/addons/TextArea/TextArea'

type AdminInfoState = {
    about: string,
    guideline: string,
    marquee: string,
    cookieExchange: string,
    keywordsExchange: string,
    keywordsExcept: string,
}

export class AdminInfo extends React.Component {
    state: AdminInfoState = {
        about: '',
        guideline: '',
        marquee: '',
        cookieExchange: '',
        keywordsExchange: '',
        keywordsExcept: ''
    }

    componentDidMount() {
        adminService.getAbout()
            .then(about => this.setState({
                about: about
            }))
            .catch(error => toast.error(error.message))
        adminService.getGuideline()
            .then(guideline => this.setState({
                guideline: guideline
            }))
            .catch(error => toast.error(error.message))
        adminService.getMarqueeText()
            .then(marquee => this.setState({
                marquee: marquee
            }))
        adminService.getCookieExchange()
            .then(cookie => this.setState({
                cookieExchange: cookie
            }))
            .catch(error => toast.error(error.message))
        adminService.getKeywordsExchange()
            .then(keywords => this.setState({
                keywordsExchange: keywords
            }))
            .catch(error => toast.error(error.message))
        adminService.getKeywordsExcept()
            .then(keywords => this.setState({
                keywordsExcept: keywords
            }))
            .catch(error => toast.error(error.message))
    }

    onDataAboutChange = (event: React.FormEvent<HTMLTextAreaElement>, data: TextAreaProps) => {
        this.setState({
            about: data.value
        })
    }

    onGuideLineChange = (event: React.FormEvent<HTMLTextAreaElement>, data: TextAreaProps) => {
        this.setState({
            guideline: data.value
        })
    }

    onMarqueeChange = (event: React.FormEvent<HTMLTextAreaElement>, data: TextAreaProps) => {
        this.setState({
            marquee: data.value
        })
    }

    onCookieExchangeChange = (event: React.FormEvent<HTMLTextAreaElement>, data: TextAreaProps) => {
        this.setState({
            cookieExchange: data.value
        })
    }

    onKeywordsExchangeChange = (event: React.FormEvent<HTMLTextAreaElement>, data: TextAreaProps) => {
        this.setState({
            keywordsExchange: data.value
        })
    }

    onKeywordsExceptChange = (event: React.FormEvent<HTMLTextAreaElement>, data: TextAreaProps) => {
        this.setState({
            keywordsExcept: data.value
        })
    }

    onClickSubmit = () => {

        adminService.setAbout(this.state.about)
            .then(value => toast.success('Lưu giới thiệu thành công!'))
            .catch(er => toast.error(er.message))

        adminService.setGuideline(this.state.guideline.toString())
            .then(value => toast.success('Lưu hướng dẫn thành công!'))
            .catch(er => toast.error(er.message))

        adminService.setMarqueeText(this.state.marquee)
            .then(marquee => toast.success('Lưu chữ chạy thành công!'))
            .catch(er => toast(er.message))

        adminService.setCookieExchange(this.state.cookieExchange)
            .then(cookie => toast.success('Lưu cookie exchange thành công!'))
            .catch(er => toast(er.message))

        adminService.setKeywordsExchange(this.state.keywordsExchange)
            .then(keywords => toast.success('Lưu keywords exchange thành công!'))
            .catch(er => toast(er.message))

        adminService.setKeywordsExcept(this.state.keywordsExcept)
            .then(keywords => toast.success('Lưu keywords loại trừ exchange thành công!'))
            .catch(er => toast(er.message))

    }

    render() {
        const {about, guideline, marquee, cookieExchange, keywordsExchange, keywordsExcept} = this.state
        return (
            <Segment style={{border: 'none'}}>
                <Segment>
                    <Form>
                        <Label pointing={'below'}>Cookie Exchange</Label>
                        <TextArea value={cookieExchange} onChange={this.onCookieExchangeChange}/>
                    </Form>
                </Segment>
                <Segment>
                    <Form>
                        <Label pointing={'below'}>Từ khóa tự động Exchange</Label>
                        <TextArea value={keywordsExchange} onChange={this.onKeywordsExchangeChange}/>
                    </Form>
                </Segment>
                <Segment>
                    <Form>
                        <Label pointing={'below'}>Từ khóa loại trừ tự động Exchange</Label>
                        <TextArea value={keywordsExcept} onChange={this.onKeywordsExceptChange}/>
                    </Form>
                </Segment>
                <Segment>
                    <Form>
                        <Label pointing={'below'}>Giới thiệu</Label>
                        <TextArea value={about} onChange={this.onDataAboutChange} style={{minHeight: 400}}/>
                    </Form>
                </Segment>
                <Segment>
                    <Form>
                        <Label pointing={'below'}>Hướng dẫn sử dụng</Label>
                        <TextArea value={guideline} onChange={this.onGuideLineChange}/>
                    </Form>
                </Segment>
                <Segment>
                    <Form>
                        <Label pointing={'below'}>Dòng chữ chạy</Label>
                        <TextArea value={marquee} onChange={this.onMarqueeChange}/>
                    </Form>
                </Segment>
                <Button primary={true} onClick={this.onClickSubmit}>Save</Button>
            </Segment>
        )
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/Admin/containers/AdminInfo.tsx